var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightPanelExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.193 24.02a.686.686 0 000 .953l3.718 3.829a.64.64 0 00.927 0 .689.689 0 000-.954l-2.597-2.672 11.103-.003c.363 0 .656-.3.656-.675a.664.664 0 00-.656-.675H10.24l2.598-2.672a.686.686 0 000-.954.643.643 0 00-.927 0L8.193 24.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 7.625c.619 0 1.125.506 1.125 1.125v4.5H5.375v-4.5c0-.619.506-1.125 1.125-1.125h27zM5.375 31.25V16.625H24.5v15.75h-18a1.128 1.128 0 01-1.125-1.125zm22.5 1.125v-15.75h6.75V31.25c0 .619-.506 1.125-1.125 1.125h-5.625zM6.5 4.25A4.504 4.504 0 002 8.75v22.5c0 2.482 2.018 4.5 4.5 4.5h27c2.482 0 4.5-2.018 4.5-4.5V8.75c0-2.482-2.018-4.5-4.5-4.5h-27z"
  })));
}
export default SvgRightPanelExpand;